import { useState } from "react";
import { useFrontofficeContext } from "../../context/FrontofficeContext";
import { useParameterContext } from "../../context/ParameterContext";
import useAutoReload from "../../hooks/useAutoReload";
import useScannerListener from "../../hooks/useScannerListener";
import FrontofficePageView from "./FrontofficePageView";

function FrontofficePage() {
  const { updatePage, pageName, terminal } = useFrontofficeContext();
  const parameterContext = useParameterContext();
  const [idle, setIdle] = useState(false);
  const [settingsOpen, setSettingsOpen] = useState(false);
  useScannerListener(onQRScan);

  //The screensaver only runs with a terminal, so without one the idle state is outdated
  useAutoReload(idle && !!terminal && !settingsOpen, getReloadInterval());

  /**
   * This method will handle the QR scan event
   * @param {string} value
   */
  function onQRScan(value) {
    if (pageName === "visitor_type") {
      return;
    }

    updatePage("registration_code", {
      registrationCode: value,
    });
  }

  /**
   * This method will return the interval after which the terminal reloads, so it picks up changes
   * @returns {number}
   */
  function getReloadInterval() {
    return (
      Number(
        parameterContext.getParameter("terminal.reload.interval")?.value ?? 60,
      ) *
      60 *
      1000
    );
  }

  return (
    <FrontofficePageView
      onIdleChange={setIdle}
      onSettingsOpenChange={setSettingsOpen}
    />
  );
}

export default FrontofficePage;
